import React, { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import { styled } from 'main/config/theme/styledWithTheme'
import { CaretIconCP } from 'main/common/components/icons/CaretIconCP'
import { CardCP } from 'main/common/components/card/CardCP'
import loadingDocImg from 'main/common/components/pdf-viewer/inner/loading_doc.gif'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

interface IPdfViewerContentICPProps {
    file: any
    paginationType: 'scroll' | 'paginator'
    onLoadDocument?: () => void
}

/**
 * COMPONENTE: Visualizador de PDF
 */
export function PdfViewerContentICP(props: IPdfViewerContentICPProps): JSX.Element | null {

    const [totalPages, setTotalPages] = useState<number>(0)
    const [showPage, setShowPage] = useState<number>(1)
    const [showPageIndicator, setShowPageIndicator] = useState<boolean>(false)

    function renderPages(): JSX.Element | JSX.Element[] {

        // Se tiver paginacao, retonarna apenas uma pagina
        if (props.paginationType === 'paginator')
            return <Page pageNumber={showPage}/>

        // Senao retorna todas as paginas e tera scroll
        const jsxPages: JSX.Element[] = []

        for (let i = 0; i < totalPages; i++) {
            jsxPages.push(
                <PageWrapperSCP>
                    <Page pageNumber={i + 1}/>
                </PageWrapperSCP>
            )
        }

        return jsxPages
    }

    function onLoadDocument(numPages: number): void {

        setTotalPages(numPages)
        setShowPageIndicator(props.paginationType === 'paginator')

        if (props.onLoadDocument)
            props.onLoadDocument()

    }

    return (
        <ViewerWrapperSCP>
            <DocumentSCP isFixedSize={props.paginationType === 'paginator'}>
                <Document
                    file={props.file}
                    loading={
                        <CardCP>
                            <LoadingWrapperSCP>
                                <div>
                                    <img src={loadingDocImg}/>
                                    <LoadingTextSCP>
                                        ... carregando documento ...
                                    </LoadingTextSCP>
                                </div>
                            </LoadingWrapperSCP>
                        </CardCP>
                    }
                    onLoadSuccess={({ numPages }) => onLoadDocument(numPages)}
                >
                    { renderPages() }
                </Document>
            </DocumentSCP>
            {
                showPageIndicator &&
                <NavWrapperSCP>
                    {
                        showPage > 1 &&
                        <ArrowSCP onClick={() => setShowPage(showPage - 1)}>
                            <CaretIconCP direction={'left'}/>
                        </ArrowSCP>
                    }

                    { `Página ${showPage} de ${totalPages}` }

                    {
                        showPage < totalPages &&
                        <ArrowSCP onClick={() => setShowPage(showPage + 1)}>
                            <CaretIconCP direction={'right'}/>
                        </ArrowSCP>
                    }
                </NavWrapperSCP>
            }
        </ViewerWrapperSCP>
    )
}

const DocumentSCP = styled.div<{ isFixedSize: boolean }>`
    
    width: ${props => props.isFixedSize ? '' : '90%'};
    max-width: ${props => props.isFixedSize ? '' : '1000px'};
    
    canvas {
        height: ${props => props.isFixedSize ? '80vh !important' : 'auto !important'};
        width: ${props => props.isFixedSize ? 'auto !important' : '100% !important'};
    }
`

const LoadingWrapperSCP = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ViewerWrapperSCP = styled.div`
    background: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
`

const NavWrapperSCP = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
`

const ArrowSCP = styled.div`
    margin: 4px;
    padding: 4px;
    cursor: pointer;
`

const PageWrapperSCP = styled.div`
  margin-bottom: 10px;
`

const LoadingTextSCP = styled.div`
  animation: blink 3s linear infinite;
  margin-top: 10px;
  
  @keyframes blink{
    0%{opacity: .2;}
    20%{opacity: .6;}
    40%{opacity: 1;}
    60%{opacity: 1;}
    80%{opacity: .6;}
    100%{opacity: .2;}
  }
`